/** Human-readable entity labels for audit log UI (aligned with backend entityType slugs). */
import { describeAuditChanges, getAuditRecordTitle } from "./auditDiff";
export const AUDIT_ENTITY_LABELS = {
  user: "User",
  teacher: "Teacher",
  student: "Student",
  course: "Course",
  subject: "Subject",
  class: "Class",
  department: "Department",
  exam: "Exam",
  timetable: "Timetable",
  time_table: "Timetable",
  event: "Event",
  notice: "Notice",
  assignment: "Assignment",
  attendance: "Attendance",
  material: "Study Material",
  grade: "Grade",
  result: "Result",
  fee: "Fee Payment",
  library: "Library Book",
  inventory: "Inventory Item",
  role: "Role",
  permission: "Permission",
  rbac: "Roles & Permissions",
  rbac_permission: "Role Permission",
  rolepermission: "Role Permission",
  role_permission: "Role Permission",
  rolepermissionoverride: "Institute Permission Override",
  bulk_update_permissions: "Permission Matrix Update",
  role_permission: "Role Permission",
  rolepermission: "Role Permission",
  rolepermissionoverride: "Institute Permission Override",
  conversation: "Conversation",
  chatgroup: "Chat Group",
  leave: "Leave",
  institute: "Institute",
  auth: "Authentication",
  device_auth: "Device Login",
  fee_head: "Fee Head",
  fee_structure: "Fee Structure",
  fee_assignment: "Student Fee Assignment",
  fee_payment: "Fee Payment",
  fee_receipt: "Fee Receipt",
  fee_payment_setup: "Payment Setup",
};

export function getAuditEntityLabel(entityType) {
  const key = String(entityType || "").trim().toLowerCase();
  if (!key) return "Record";
  return AUDIT_ENTITY_LABELS[key] || key.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
}

export function getAuditActionLabel(action) {
  const map = {
    create: "Created",
    read: "Viewed",
    read_list: "Viewed list of",
    update: "Modified",
    delete: "Deleted",
    bulk_update_permissions: "Updated permissions for",
    login: "Logged in",
    logout: "Logged out",
    login_failed: "Failed login",
    device_pending: "Device pending approval",
    device_approved: "Device approved",
    device_rejected: "Device rejected",
  };
  return map[action] || (action ? String(action).replace(/_/g, " ") : "Unknown action");
}

export function getAuditSummary(log, references) {
  if (!log?.action) return "Unknown action";
  const newVal = log.newValue && typeof log.newValue === "object" ? log.newValue : null;
  if (newVal?.summary) return newVal.summary;
  const actionLabel = getAuditActionLabel(log.action);
  const entityLabel = getAuditEntityLabel(log.entityType);
  const recordTitle = getAuditRecordTitle(log);

  if (log.action === "read_list") return `${actionLabel} ${entityLabel}s`;

  if (log.action === "create") {
    const newVal =
      log.newValue && typeof log.newValue === "object" ? log.newValue : null;
    if (newVal?.generationType) {
      const slotLabel =
        newVal.slotCount != null ? ` — ${newVal.slotCount} slots` : "";
      const title = newVal.name || recordTitle;
      return title
        ? `${newVal.generationType}: ${title}${slotLabel}`
        : `${newVal.generationType}${slotLabel}`;
    }
    if (recordTitle) return `${actionLabel} ${entityLabel}: ${recordTitle}`;
    return `${actionLabel} ${entityLabel}`;
  }

  if (log.action === "delete") {
    if (recordTitle) return `${actionLabel} ${entityLabel}: ${recordTitle}`;
    return `${actionLabel} ${entityLabel}`;
  }

  if (log.action === "update") {
    const changeDetail = describeAuditChanges(log.oldValue, log.newValue, log.entityType, references);
    if (changeDetail) {
      if (recordTitle) return `${actionLabel} ${entityLabel} (${recordTitle}) — ${changeDetail}`;
      return `${actionLabel} ${entityLabel} — ${changeDetail}`;
    }
    if (recordTitle) return `${actionLabel} ${entityLabel}: ${recordTitle}`;
    return `${actionLabel} ${entityLabel}`;
  }

  return `${actionLabel} ${entityLabel}`;
}
